import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FallAufgabenStatus, KorrektorUserTokenContents } from '@reflact/ipkv-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Status {
  public status: FallAufgabenStatus<string, string>[] = [];
  public filteredStatus: FallAufgabenStatus<string, string>[] = [];
  public selectedStatus: FallAufgabenStatus<string, string> = {kiComment:"",nachKorrekturComment:"",nachkorrekturFinishedDate:"", korrektorComment:"", _id: '', chatHistoryItems: [], created: '', endDate: '', fallaufgabenId: '', korrektorFinishedDate: '', startDate: '', updated: '', userId: '', versionsUnique: '', isAdminTest: false, userSelectedAufgabenId: '' };
  private http = inject(HttpClient);
  private baseRoute = "/api/admin/fallaufgabenstatus";

  public async get() {
    this.status = await firstValueFrom(this.http.get<FallAufgabenStatus<string, string>[]>(this.baseRoute + "/list"));
  }

  public set(id: string) {
    const status = this.filteredStatus.find(s => s._id === id);
    if (status) this.selectedStatus = status;
  }

  public reset() {
    this.selectedStatus = {nachkorrekturFinishedDate:"",nachKorrekturComment:"",kiComment:"", korrektorComment:"", _id: '', chatHistoryItems: [], created: '', endDate: '', fallaufgabenId: '', korrektorFinishedDate: '', startDate: '', updated: '', userId: '', versionsUnique: '', isAdminTest: false, userSelectedAufgabenId: '' };
  }

  public async getKiResultsForStatus() {
    const result = await firstValueFrom(this.http.post(this.baseRoute + "/getkiresults", { fallaufgabenStatusId: this.selectedStatus._id }));
    console.log("Results", result)
    return result
  }

  public async getKorrekturFallausgabenStatusLink(role: KorrektorUserTokenContents['role'], correctionType: KorrektorUserTokenContents['correctionType']) {
    const result = await firstValueFrom(this.http.post<{ link: string }>(this.baseRoute + "/getkorrekturlinkforstatus", { fallaufgabenStatusId: this.selectedStatus._id, role, correctionType }));
    return result.link
  }

  public async getUserFallausgabenStatusLink() {
    const result = await firstValueFrom(this.http.post<{ link: string }>(this.baseRoute + "/getuserlinkforrunningaufgabe", { fallaufgabenStatusId: this.selectedStatus._id }));
    return result.link
  }

  public async getFallausgabenStatusKir(fallaufgabenStatusId: string) {
    const result = await firstValueFrom(this.http.post<{ link: string }>(this.baseRoute + "/getuserlinkforrunningaufgabe", { fallaufgabenStatusId }));
    return result.link
  }

  public async getNewUserLinkForFallaufgabe(fallaufgabenId: string) {
    const result = await firstValueFrom(this.http.post<{ link: string }>(this.baseRoute + "/getnewuserlinkforfallaufgabe", { fallaufgabenId }));
    return result.link
  }

  public async delete() {
    const data = await firstValueFrom(this.http.post<{ deleted: FallAufgabenStatus }>(this.baseRoute + "/delete", { fallaufgabenStatusId: this.selectedStatus._id }));
    const index = this.filteredStatus.findIndex(status => status._id === data.deleted._id);
    if (index !== -1) {
      this.filteredStatus.splice(index, 1);
    }
  }
}